import React from "react";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import Modal from "./Modal";

/**
 * Shown when a saved Create Event draft already exists, mirroring mobile's
 * "Continue draft / Discard and start new / Cancel" alert in
 * Component/modals/create-event-for-promoter/index.js.
 */
const DraftPromptModal = ({ onClose, onResume, onDiscard }) => {
  const { t } = useTranslation("common");
  return (
    <Modal
      title={t("draftPromptModal.title")}
      onClose={onClose}
      maxWidth={440}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>{t("actions.cancel")}</Button>
          <Button variant="danger" onClick={onDiscard}>{t("draftPromptModal.discardAndNew")}</Button>
          <Button onClick={onResume}>{t("draftPromptModal.continueDraft")}</Button>
        </>
      }
    >
      <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55 }}>
        {t("draftPromptModal.message")}
      </p>
    </Modal>
  );
};

export default DraftPromptModal;
